export enum RelayState {
    SignReport = 'signRpt',
    ReportSigningCancelled = 'cancelSignRpt',
    SignReportStatusChange = 'signRptStatus',
    ReportStatusChangeSigningCancelled = 'cancelSignRptStatus',
}
